// src/data/teamData.js
export const teamMembers = [
  {
    id: 1,
    name: "Evelio Bustos Apache",
    position: "Director / Contador Público",
    specialty: "Revisoría Fiscal | Contraloría | Auditoría",
    email: "consultores@eveliobustosapache.com",
    photo: require('../img/evelio.png'),  // ✅ Con require() y extensión .png
    experience: "15+ años",
    description: `Contador Público con más de 15 años de experiencia en la prestación de servicios contables, fiscales y financieros, orientados al fortalecimiento empresarial y la toma de decisiones estratégicas. Se ha destacado por brindar soluciones integrales a empresas y emprendedores, garantizando el cumplimiento normativo, la transparencia en la gestión y la sostenibilidad financiera.

Cuenta con sólida experiencia en revisoría fiscal, contraloría y auditorías, aportando valor a las organizaciones mediante la implementación de controles eficientes, la optimización de procesos y la mitigación de riesgos. Su enfoque profesional se centra en generar confianza, mejorar la rentabilidad y acompañar el crecimiento estructurado de sus clientes.`,
    education: [
      "Contador Público",
      "Especialista en Revisoría Fiscal y Contraloría",
      "Diplomado en Contratación Pública",
      "Auditor Interno en Sistemas Integrados de Gestión",
      "Diplomado en Planeación Estratégica",
      "Formación en Contratación Estatal y Control Interno"
    ]
  },
  {
    id: 2,
    name: "Karen Lucía Ruíz Romero",
    position: "Coordinadora de Gestión Financiera",
    specialty: "Revisoría Fiscal | Gestión Organizacional | Control Interno",
    email: "consultores@eveliobustosapache.com",
    photo: require('../img/karen.png'),  // ✅ Con require() y extensión .png
    experience: "29+ años",
    description: `Contadora Pública, Magíster en Gestión de Organizaciones y Especialista en Revisoría Fiscal y Contraloría, con más de 29 años de experiencia profesional en el sector comercial, educativo y empresarial, destacándose por su liderazgo estratégico, su ética profesional y su enfoque en el fortalecimiento organizacional.

A lo largo de su trayectoria ha liderado procesos financieros, administrativos y de control interno en diferentes organizaciones, desempeñándose como Contadora en la Cámara de Comercio de Montería, donde contribuyó al fortalecimiento de la gestión contable y al desarrollo empresarial de la región.

En el ámbito educativo, ejerció como educadora en la Institución Educativa Nuestra Señora de Fátima de Montería y como Rectora de la Institución Educativa Liceo Villa Caribe, promoviendo procesos de formación integral, liderazgo académico y fortalecimiento institucional.`,
    education: [
      "Contadora Pública",
      "Magíster en Gestión de Organizaciones",
      "Especialista en Revisoría Fiscal y Contraloría",
      "Amplia experiencia en sector comercial, educativo y empresarial"
    ]
  }
];